import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IUser } from 'src/app/shared/interfaces/user.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private _http: HttpClient) {}

  login(loginData: {email: string, password: string} ) : Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}/users/login`, loginData);
  }

  checkAutentication(token: string): Observable<boolean>   {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${token}`);
    return this._http.get<IUser>(`${environment.apiUrl}/users/checkAuthentication`, { headers})
    .pipe(
      map( res =>{
      if(res){
        return true
      } else {
        return false
      }}
        )
    )
  }

  smsConfirmation(phone: string, text: string) : Observable<any> | undefined {
    //TODO: la petición no se debe hace desde aqui
    const url = `${environment.smsUrl}/sms/1/text/single`;

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        //TODO: esto no debe ir quemado
        authorization: 'Basic T05FRUNPTU1FUkNFLlNNUzpPbmVtYWxsLjIwMjM='
      }
    }

    const body = {
      from: environment.businessName,
      to: phone,
      text: text
    }

    return this._http.post(url, body, options)
  }

  getRecoverPasswordLink(email: string): Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}/users/recoverPassword`, { email });
  }

  changePassword(password: string, confirmation: string, token: string) : Observable<any> {
    const headers = {
      "Authorization" : `Bearer ${token}`
    };
    return this._http.put<any>(`${environment.apiUrl}/users/recoverChangePassword`,{
      password: password,
      confirmation: confirmation
    },{
      headers
    }
    );
  }
}
